"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ProviderHoc_1 = __importDefault(require("../../hoc/ProviderHoc"));
const react_redux_1 = require("react-redux");
const dom_1 = require("../../utils/dom");
class DecibelWrapper extends react_1.Component {
    componentDidMount() {
        const { profile } = this.props;
        const shouldDecibelBeAppended = profile.provisioning[DigProvisions.ENABLE_DXA_IN_COMMAND_CENTER] && !document.getElementById('dxa4');
        if (shouldDecibelBeAppended) {
            const el1 = (0, dom_1.createDomNode)('link', { id: 'dxa1', rel: 'dns-prefetch', href: '//cdn.decibelinsight.net' });
            const el2 = (0, dom_1.createDomNode)('link', { id: 'dxa2', rel: 'dns-prefetch', href: '//collection.decibelinsight.net' });
            const el3 = (0, dom_1.createDomNode)('script', { id: 'dxa3', type: 'text/javascript', innerHTML: `// <![CDATA[
        (function(d,e,c,i,b,el,it)
        { d._da_=d._da_||[];_da_.oldErr=d.onerror;_da_.err=[]; d.onerror=function()\{_da_.err.push(arguments);
          _da_.oldErr&&_da_.oldErr.apply(d,Array.prototype.slice.call(arguments));};
        d.DecibelInsight=b;d[b]=d[b]||function(){(d[b].q=d[b].q||[]).push(arguments);};
        el=e.createElement(c),it=e.getElementsByTagName(c)[0];el.async=1;el.src=i;el.id='dxa4';it.parentNode.insertBefore(el,it);
        })(window,document,'script','https://cdn.decibelinsight.net/i/13798/1058292/di.js','decibelInsight');
        // ]]>` });
            document.head.prepend(el1, el2, el3);
        }
    }
    componentWillUnmount() {
        if (window.decibelInsight) {
            // Terminate the screen-recording
            window.decibelInsight('setCollection', false);
            ['dxa1', 'dxa2', 'dxa3', 'dxa4'].forEach(id => {
                const el = document.getElementById(id);
                el === null || el === void 0 ? void 0 : el.remove();
            });
            window.onerror = window._da_.oldErr;
            delete window._da_;
            delete window.DecibelInsight;
            delete window['decibelInsight'];
        }
    }
    render() {
        return false;
    }
}
function mapStateToProps({ profile }) {
    return {
        profile,
    };
}
exports.default = (0, ProviderHoc_1.default)()((0, react_redux_1.connect)(mapStateToProps)(DecibelWrapper));
